<template>
    <div class="carOrderItem-wrap">
        <div class="carOrderItem">
            <div class="route-info">
                <div class="route-name">
                    <div class="route-name-icon" :class="{ active: isCruiseSelected}" @click="onCruiseSelected(shoppingCarts)">
                        <img src="https://resource.rcclchina.com.cn/tui2/packageGuestInfo/icon10.png">
                    </div>
                    <router-link :to='cruiseLink' class="route-name-txt external">
                        {{cruise.cruiseRoute}}
                    </router-link>
                </div>
                <div class="route-ship">{{cruise.sailDays}}天{{cruise.sailDays-1}}晚 {{ship.shipCNName}}</div>
                <div class="route-row">
                    <div class="route-row-title">游轮往返：</div>
                    <div class="route-row-txt">{{sailDateBegin}} - {{sailDateEnd}}</div>
                </div>
                <div class="route-collectionRow">
                    <span @click="onDeleteCruiseClicked(shoppingCart.shipCode, shoppingCart.sailDate, shoppingCart.packageId, shoppingCart.cruiseId)">移入收藏夹</span>
                    <div class="route-collectionRow-img">
                        <img class="normal" src="https://resource.rcclchina.com.cn/tui2/shoppingcart/icon04.png">
                    </div>
                </div>
                <div class="route-line"></div>
            </div>
            <ShoppingCartStateroom v-for="(normalStateroom, i) in normalStaterooms"
                :key="('normalStaterooms_'+i)"
                :shoppingCarts="normalStateroom.shoppingCarts"
                :selectedShoppingCarts="normalSelected"
                :onStateroomSelected="onStateroomSelected"
                :onAddShoppingCart="onAddShoppingCart"
                :onDeleteShoppingCart="onDeleteShoppingCart"
                :onDeleteByStateroom="onDeleteByStateroom"
                :showQiaohuPopup="showQiaohuPopup"
                :showStarrySkyPopup="showStarrySkyPopup"
                :showCustomThemePopup="(val)=> showCustomThemePopup(val)"
                @detail="showStateroomDetailPopup"
            />
            <ShoppingCartConnectRoom v-if="connectStaterooms&&connectStaterooms.length == 2"
                :shoppingCarts="connectStaterooms"
                :selectedShoppingCarts="connectSelected"
                :onConnectRoomSelected="onConnectRoomSelected"
                :onDeleteConnectRoom="onDeleteConnectRoom"
                :showConnectRoomPopup="showConnectRoomPopup"
                :showQiaohuPopup="showQiaohuPopup"
                :showStarrySkyPopup="showStarrySkyPopup"
                :showCustomThemePopup="(val)=> showCustomThemePopup(val)"
                @detail="showStateroomDetailPopup"
            />
            <StateroomDetail
               :onGoBack="closeStateroomDetailPopup"
               :isShow="isShowStateroomDetailPopup"
               :stateroomDetail="stateroomDetail"
            />
        </div>
    </div>
</template>

<script>
import { pageScroll } from "@/utilities/tools";
import moment from 'moment'
const ShoppingCartStateroom = () => import('@/components/Booking/ShoppingCartStateroom')
const ShoppingCartConnectRoom = () => import('@/components/Booking/ShoppingCartConnectRoom')
const StateroomDetail = ()=> import("@/components/Booking/StateroomDetail");
export default {
    name: "ShoppingCartCruise",
    components: {
        ShoppingCartStateroom,
        ShoppingCartConnectRoom,
        StateroomDetail
    },
    props: {
        shoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        selectedShoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        onCruiseSelected: {
            type: Function
        },
        onStateroomSelected: {
            type: Function
        },
        onConnectRoomSelected: {
            type: Function
        },
        onAddShoppingCart: {
            type: Function
        },
        onDeleteShoppingCart: {
            type: Function
        },
        onDeleteConnectRoom: {
            type: Function
        },
        onDeleteByStateroom: {
            type: Function
        },
        onDeleteCruiseClicked: {
            type: Function
        },
        showConnectRoomPopup: {
            type: Function
        },
        showQiaohuPopup: {
            type: Function
        },
        showStarrySkyPopup: {
            type: Function
        },
        showCustomThemePopup: {
          type: Function
        }
    },
    data() {
      return {
        isShowStateroomDetailPopup: false,
        stateroomDetail: null
      }
    },
    methods: {
      showStateroomDetailPopup(val) {
        this.isShowStateroomDetailPopup = true;
        console.log(val)
        this.stateroomDetail = Object.assign({}, val);
        pageScroll(false);
        this.showPopup()
      },
      closeStateroomDetailPopup() {
        this.isShowStateroomDetailPopup = false
        pageScroll(true);
      },
      showPopup() {
        history.pushState({ page: 'shoppingCart' }, null);
      },
    },
    computed: {
        cruise() {
            if (this.shoppingCarts && this.shoppingCarts.length > 0) {
                return this.shoppingCarts[0].cruisePartRecord
            }
            return {}
        },
        cruiseLink () {
            return `/Rccl.Cruise/CruiseDetail?sailDate=${this.shoppingCart.sailDate}&shipCode=${this.shoppingCart.shipCode}`
        },
        shoppingCart () {
            if (!this.shoppingCarts || this.shoppingCarts.length == 0) {
                return {}
            }
            return this.shoppingCarts[0]
        },
        ship () {
            return this.cruise.shipPartViewModel || {}
        },
        sailDateBegin () {
            const sailDate = moment(this.cruise.sailDate)
            return sailDate.format('yyyy/MM/DD')
        },
        sailDateEnd () {
            const sailDate = moment(this.cruise.sailDate)
            return sailDate.add(this.cruise.sailDays - 1, 'days').format('yyyy/MM/DD')
        },
        // 非连通房的舱房，数据结构 count: number, categoryCode: 1D, isnrp: false, groupTyp: '' , shoppingCarts: []
        normalStaterooms () {
            const shoppingCarts = this.shoppingCarts.filter(r=>!r.connectId || r.connectId == '')
            let staterooms = []
            shoppingCarts.forEach((shoppingCart) => {
                let amountPerNight = (shoppingCart.netAmount/shoppingCart.guestNumber) / (this.cruise.sailDays - 1);
                shoppingCart.amountPerNight = amountPerNight ? amountPerNight.toFixed(0) : null;
                let stateroom = staterooms.filter(r=>r.categoryCode == shoppingCart.berthedCategoryCode
                && r.isnrp == shoppingCart.isnrp && r.groupType == shoppingCart.groupType)
                if (stateroom && stateroom.length > 0) {
                    stateroom[0].count++
                    stateroom[0].shoppingCarts.push(shoppingCart)
                } else {
                    staterooms.push({
                        count: 1,
                        categoryCode: shoppingCart.berthedCategoryCode,
                        groupType: shoppingCart.groupType,
                        isnrp: shoppingCart.isnrp,
                        shoppingCarts: [shoppingCart]
                    })
                }
            })
            return staterooms
        },
        connectStaterooms () {
          let data = [];
          this.shoppingCarts.forEach(r=> {
            let amountPerNight = (r.netAmount/r.guestNumber) / (this.cruise.sailDays - 1);
            r.amountPerNight = amountPerNight ? amountPerNight.toFixed(0) : null;
            if(r.connectId && r.connectId.length > 0) {
              data.push(r)
            }
          })
          return data;
        },
        normalSelected () {
            return this.selectedShoppingCarts.filter(r=>!r.connectId || r.connectId == '')
        },
        connectSelected () {
            return this.selectedShoppingCarts.filter(r=>r.connectId && r.connectId.length > 0)
        },
        isCruiseSelected () {
            // 检查航线是否都被选中
            return this.selectedShoppingCarts.length == this.shoppingCarts.length
        }
    }
}
</script>

<style lang="less" scoped>
img {
    max-width: 100%;
}
.carOrderItem {
    margin-bottom: 10px;
    //padding: 13px 20px 0;
    padding: 13px 13px 0;
    background-color: #fff;
    .route-info {
        position: relative;
        padding-bottom: 1px;
        .route-name {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            padding-bottom: 5px;
            .route-name-icon {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -moz-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                width: 15px;
                height: 15px;
                margin-right: 5px;
                margin-top: 3px;
                border: 1px solid #4A90E2;
                border-radius: 100%;
                img {
                    display: none;
                    width: 12px;
                }
            }
            .route-name-icon.active {
                background-color: #4A90E2;
                img {
                    display: block;
                }
            }
            .route-name-txt {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                display: block;
                font-size: 14px;
                line-height: 20px;
                color: #333;
                font-weight: bold;
            }
        }
        .route-ship {
            margin-left: 20px;
            padding-bottom: 6px;
            font-size: 12px;
            line-height: 16px;
            color: #666;
        }
        .route-row {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            margin-left: 20px;
            padding-bottom: 6px;
            .route-row-title {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                font-size: 12px;
                line-height: 16px;
                color: #666;
            }
            .route-row-txt {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                font-size: 12px;
                line-height: 16px;
                color: #151515;
            }
        }
        .route-collectionRow {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: end;
            -webkit-justify-content: flex-end;
            -moz-box-pack: end;
            -ms-flex-pack: end;
            justify-content: flex-end;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-top: -6px;
            padding-bottom: 8px;
            font-size: 12px;
            line-height: 16px;
            color: #4A90E2;
            .route-collectionRow-img {
                width: 17px;
                margin-left: 4px;
            }
        }
    }
}
</style>
